import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TiptapEditorComponent } from '@components/tiptap/tiptap-editor/tiptap-editor.component';
import {
  GetOutlineInputTopicBody,
  ScriptEvidence,
} from '@models/Sessions/Idea/podcast-api';
import { PodcastService } from '@services/sessions/podcast.service';
import { omit } from 'lodash';

import { RefsListComponent } from '../../refs-list/refs-list.component';

interface OutlineForm {
  outline: FormControl<object | null>;
}

@Component({
  selector: 'app-outline-form',
  standalone: true,
  imports: [ReactiveFormsModule, RefsListComponent, TiptapEditorComponent],
  templateUrl: './outline-form.component.html',
  styleUrl: './outline-form.component.scss',
})
export class OutlineFormComponent implements OnInit {
  @Input() params!: GetOutlineInputTopicBody & { includeResearch: boolean };

  form!: FormGroup<OutlineForm>;
  isGenerateOutline = true;
  refs: ScriptEvidence[] = [];

  private formBuilder = inject(FormBuilder);
  private podcastService = inject(PodcastService);
  private destroyRef = inject(DestroyRef);

  constructor() {
    this.createForm();
  }

  ngOnInit(): void {
    this.generateOutline();
  }

  private createForm() {
    this.form = this.formBuilder.group({
      outline: this.formBuilder.control(null, [Validators.required]),
    });
  }

  private generateOutline() {
    this.podcastService
      .generateOutlineInputTopic(
        omit(this.params, 'includeResearch'),
        this.params.includeResearch,
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({ outline, evidence }) => {
        this.form.get('outline').patchValue(outline as unknown as object);
        this.refs = evidence;
        this.isGenerateOutline = false;
      });
  }
}
